import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { phoneRegExp } from "../../../../utils/Functions/table";
import { updateApiSettings } from "../api";

const useAddUsers = ({ aiSettingsState, setAiSettingsState, refetch }) => {
  const validation = Yup.object({
    add_user: Yup.string()
      .matches(phoneRegExp, "Please enter a valid phone number")
      .min(8, "Number should be at least 8 characters long")
      .max(8, "Number should be 8 characters long"),

    icon_percentage: Yup.string()
      .required("Percentage is required")
      .matches(/^\d+$/, "Percentage must be a number"),

    status: Yup.string(),
    user_mobiles: Yup.array(),
  });

  const formik = useFormik({
    initialValues: {
      add_user: "",
      icon_percentage: aiSettingsState?.itemData?.icon_percentage ?? "",
      user_mobiles: aiSettingsState?.itemData?.user_mobiles ?? [],
      status: aiSettingsState?.itemData?.status ?? 2,
    },
    validationSchema: validation,
    onSubmit: (values, { setSubmitting }) => {
      let data = {
        user_mobiles: values?.user_mobiles,
        icon_percentage: values?.icon_percentage,
        id: aiSettingsState?.itemId,
        status: values?.status,
      };
      updateApiSettings(data).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success(`Succesfully Added`);
          refetch();
          handleCloseModal();
          setSubmitting(false);
        } else if (
          response?.data?.status_code === 422 &&
          response?.data?.errors
        ) {
          Object.keys(response?.data?.errors).forEach((field) => {
            formik.setFieldError(field, response?.data?.errors[field]);
          });
          setSubmitting(false);
        } else {
          toast.error(`Something went wrong!`);
          handleCloseModal();
          setSubmitting(false);
        }
      });
    },
  });
  const handleAddSelectedUser = () => {
    if (formik?.values?.add_user !== "" && !formik?.errors?.add_user) {
      if (!formik?.values?.user_mobiles?.includes(formik?.values?.add_user)) {
        formik.setFieldValue("user_mobiles", [
          ...formik.values.user_mobiles,
          formik?.values?.add_user,
        ]);
        formik.setFieldValue("add_user", "");
      } else {
        formik.setFieldError("add_user", "Number is already added");
      }
    }
  };

  const handleRemoveSelectedUser = (index) => {
    if (index > -1 && index < formik?.values?.user_mobiles.length) {
      const updatedUsers = [...formik.values.user_mobiles];
      updatedUsers.splice(index, 1);

      formik.setFieldValue("user_mobiles", updatedUsers);
    }
  };
  const handleCloseModal = () => {
    setAiSettingsState((prev) => ({
      ...prev,
      showModal: false,
    }));
  };
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  return {
    formik,
    getFieldError,
    handleAddSelectedUser,
    handleRemoveSelectedUser,
    handleCloseModal,
  };
};

export default useAddUsers;
